import { render, staticRenderFns } from "./SoUpload.vue?vue&type=template&id=c587e0d0&scoped=true&"
import script from "./SoUpload.vue?vue&type=script&lang=js&"
export * from "./SoUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c587e0d0",
  null
  
)

export default component.exports